import type { IconData } from '@stacksjs/iconify-core'

export const endPointDiamondRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M38.608 14.767a2.96 2.96 0 0 0-3.975 0a76 76 0 0 0-3.674 3.508a90 90 0 0 0-2.102 2.198c-1.655-.008-3.524-.013-5.632-.013H2a.5.5 0 0 0-.5.5v6.08a.5.5 0 0 0 .5.5h21.225c2.108 0 3.976-.006 5.631-.014a90 90 0 0 0 2.103 2.199a76 76 0 0 0 3.674 3.508a2.96 2.96 0 0 0 3.975 0a77 77 0 0 0 3.674-3.508a76 76 0 0 0 3.463-3.721a3.04 3.04 0 0 0 0-4.008a76 76 0 0 0-3.464-3.721a76 76 0 0 0-3.673-3.508\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default endPointDiamondRemix
